module.exports = __webpack_public_path__ + "static/img/3401_phase_function_Paper_Points.ed3ac7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3401_phase_function_Paper_Points.png
// module id = aJa0
// module chunks = 0